export default class DtoKeyPossessor {
    constructor(obj) {
        this.idStation = obj.idStation
        this.contributor = obj.contributor
    }
}